import { useIntl } from 'react-intl';

import { PresetKey } from './types';

export const usePreset = (preset?: PresetKey) => {
  const intl = useIntl();

  if (!preset) {
    return {};
  }

  switch (preset) {
    case 'back':
      return {
        text: intl.formatMessage({
          id: 'Button.backText',
          defaultMessage: 'Back',
          description: 'Text for back button',
        }),
        variant: 'tertiary' as const,
      };
    case 'cancel':
      return {
        text: intl.formatMessage({
          id: 'Button.cancelText',
          defaultMessage: 'Cancel',
          description: 'Text for cancel button',
        }),
        variant: 'tertiary' as const,
      };
    case 'ai':
      return {
        icon: 'ai' as const,
        iconPosition: 'left' as const,
        status: 'ai' as const,
      };
    case 'onboarding':
      return {
        icon: 'help' as const,
        iconPosition: 'left' as const,
        text: intl.formatMessage({
          id: 'Button.onboardingText',
          defaultMessage: 'Onboarding',
          description: 'Text for onboarding button',
        }),
        variant: 'onboarding' as const,
      };
    case 'cta':
      return {
        variant: 'cta' as const,
        size: 'l' as const,
      };
    case 'cta-ai':
      return {
        icon: 'evisort-ai-static' as const,
        variant: 'cta-ai' as const,
        size: 'l' as const,
        mode: 'chip' as const,
        textVariant: 'section-title' as const,
      };
    case 'dropdown':
      return {
        variant: 'secondary' as const,
        iconPosition: 'left' as const,
      };
    default:
      return {};
  }
};
